module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8n7n2n5n-93d8ffbab5f0ea47b0a342c657a57053.svg";